var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      touchAction: "manipulation"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5876 20.3915C12.2257 20.1722 11.772 20.1722 11.4102 20.3915L5.86042 23.7553C5.00023 24.2766 3.93684 23.5052 4.16541 22.5257L5.63673 16.2204C5.73232 15.8107 5.59372 15.3818 5.27652 15.1056L0.391516 10.8515C-0.365165 10.1925 0.0416147 8.94789 1.0414 8.86299L7.47912 8.3163C7.89834 8.2807 8.26354 8.01631 8.42826 7.62917L10.9547 1.6912C11.3469 0.769598 12.6531 0.769599 13.0453 1.6912L15.5717 7.62917C15.7365 8.01631 16.1017 8.2807 16.5209 8.3163L22.9586 8.86299C23.9584 8.94789 24.3652 10.1925 23.6085 10.8515L18.7235 15.1056C18.4063 15.3818 18.2677 15.8107 18.3633 16.2204L19.8347 22.5261C20.0632 23.5056 19 24.277 18.1398 23.7558L12.5876 20.3915Z",
    fill: "#FFC500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/Stars.e4e7c679.svg";
export { ForwardRef as ReactComponent };